import { render } from "./BlackFridayHeroSection.vue?vue&type=template&id=aeeb6928&scoped=true"
import script from "./BlackFridayHeroSection.vue?vue&type=script&lang=js"
export * from "./BlackFridayHeroSection.vue?vue&type=script&lang=js"

import "./BlackFridayHeroSection.vue?vue&type=style&index=0&id=aeeb6928&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeeb6928"]])

export default __exports__